var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhy03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 419 356",
    width: 419,
    height: 356,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "why-03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t\t.s1 { fill: #ffb600 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m237.7 107.3c-6.5 4.3-20.2 9-23.9 15.9-4.4 8.1-0.2 15.9 3.5 23.4-8.6 9.3-21.7 16.2-34 19.1-78.3 18.1-123.8-88.4-54.5-131.9 51.4-32.2 120.9 13.6 108.9 73.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m367.6 83.6c4.2 4.1 2.1 21.7 8.6 29.7 4.7 5.8 22.8 11.2 24.2 15.9 1.8 6-10.1 20.9-10.1 29.7 0 8.8 12.5 24.6 9.9 30.3-2.7 5.8-21.6 8.1-26.6 19.3-2.6 5.7-2.9 23.6-6.9 26-3.8 2.2-13.7-1.2-18.3-1.5-18-1.3-17.5 5.6-28.8 14.9-6 4.9-8.2 5.8-14.6 0.8-11.8-9.3-10.8-17.1-29.5-15.7-4.5 0.3-14.7 3.6-18.3 1.5-6.3-3.8-1.4-24.9-13.2-33.5-4.2-3-19.2-8-20.5-12.3-2-6.5 8.6-19.2 9.3-26.8 0.3-2.8 0.1-6.3-0.5-9-1.6-6.6-11.8-19.4-8.2-25.2 3.4-5.5 20.5-7.5 25.6-17.5 3.2-6.3 2.9-25 7.9-27.1 5.7-2.4 19.4 3.4 28.3 1.3 10.1-2.4 17.9-17.5 24.9-18.9 6.2-1.3 16.7 14.2 22.9 17.4 9.9 5 29.9-3 33.8 0.7zm-61.2 17.6c-47.6 4.1-69.4 64-36 98.2 36.6 37.6 102.2 9 99.6-43.4-1.7-32.9-30.9-57.7-63.6-54.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m132.9 330.7h-104.3c1.2-45.5 26.6-88.3 64.9-112.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m200.7 330.7l39.4-112.3c1.1 0.1 1.1 1.1 1.4 1.8 1.5 4.2 1.1 9.8 2.9 14.6 4.6 12 15.8 13 27 9.9 19.9 24.4 33 54.1 33.6 86 0 0-104.3 0-104.3 0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m147.8 330.7l7.8-82.3h22.4l8.8 80.6c0.2 0.6-0.7 1.7-1.1 1.7h-37.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m196.3 310.3l-1.4-5.5-5.9-62.7 7.8-41.3c7.6 1.6 15.2 3.9 22.3 6.8 2.2 0.9 10.7 4.1 10.8 6.1 0 0-33.6 96.6-33.6 96.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m137.2 200.9l7.4 41.2-7 68.2-34-96.6c0.1-1.3 0.9-1.5 1.7-2 2.9-1.9 11.4-5 15-6.3 2.2-0.8 16-5.3 16.9-4.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m185.4 198.7l-6.9 37.9c-1.2 1.5-19.8 0.6-23.1 0.4l-7.2-38.3q18.6-2.4 37.2 0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m304.9 112.8c67-7.5 71.7 89.2 10 92.5-62 3.3-66.2-86.1-10-92.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy03);
export default __webpack_public_path__ + "static/media/why-03.68fb77a4ce025ee84bcf421a8d3231a5.svg";
export { ForwardRef as ReactComponent };